export class WatchListModel {
    map(arg0: (x: any) => any) {
      throw new Error('Method not implemented.');
    }
    initData = [
        { text: "My Portfolio", id: "My Portfolio", isCustom: false, isDefault: false },
        { text: "Sector", id: "Sector", isCustom: false, isDefault: false },
        { text: "Spot Watch", id: "Spot Watch", isCustom: false, isDefault: false }
    ];
    watchListOptions = this.initData.slice(0, 3);

    addWatchlist(item: string, isCustom: boolean = false, isDefault: boolean = false) {
        this.watchListOptions.push({ text: item, id: item, isCustom: isCustom, isDefault: isDefault })
    }

    getWatchlist() {
        return this.watchListOptions;
    }

    removeWatchlist(idx) {
        if (idx !== -1) {
            this.watchListOptions.splice(idx, 1);
        }
    }

    clearWatchlist() {
        this.watchListOptions = this.initData.slice(0, 3);
    }
}